import { CommonModule, JsonPipe } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IgxGridModule } from '@infragistics/igniteui-angular';
import { IgxGridComponent, IgxTabsModule } from '@infragistics/igniteui-angular';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';
import { IParkerProfileDetailForExport } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-parkers-v2-grid-view-export',
  standalone: true,
  imports: [CommonModule, JsonPipe, MatSnackBarModule, FormsModule, IgxGridModule, IgxTabsModule, IgxGridComponent],
  templateUrl: './parkers-v2-grid-view-export.component.html',
  styleUrl: './parkers-v2-grid-view-export.component.scss',
})
@ViewChild('gridExportParkersV2', { read: IgxGridComponent, static: true })
export class ParkersV2GridViewExportComponent implements OnInit {
  gridData: IParkerProfileDetailForExport[];
  public gridExportParkersV2: IgxGridComponent;
  public parkerState: ParkerStateService;

  parkerStateService = inject(ParkerStateService);

  constructor() {}

  ngOnInit(): void {}

  TransformDataForGrid(): void {}
}
